<template>

  <div class="offline">
    <div class="offline-title">
      <el-button type="primary" class="newAddBtn" @click="toAddNew">添加项目</el-button>
    </div>
    <div class="offline-body">
      <el-table
        class="dataTable"
        :data="tableData"
        style="width: 100%">
        <el-table-column
          label="ID"
          min-width="180">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="名称"
          min-width="180">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.pname }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="viewData(scope.row)">
              查看
            </el-button>
            <el-button
              size="mini"
              type="danger"
              @click="delData(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="新建项目" :visible.sync="dialogFormVisible" width="200px">
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label="项目ID" label-width="80px" prop="pro_id">
          <el-input v-model="form.pro_id" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="名称" label-width="80px" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAdd">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看标签" :visible.sync="dialogTagVisible" width="60%">
      <el-table
        class="dataTable"
        :data="tag"
        style="width: 100%">
        <el-table-column
          label="tag_id"
          min-width="180">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.tag_id }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="tag_epower"
          min-width="180">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.tag_epower }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="tag_ts"
          min-width="180">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.tag_ts }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTagVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBluetooth, actionBluetooth, getTag } from '@/api/bluetooth';

export default {
  name: 'index',
  data() {
    return {
      tag: [],
      placeList: [],
      place: '',
      tableData: [],
      activeName: '0',
      currentPage: 1,
      page_size: 20,
      total: 0,
      dialogFormVisible: false,
      dialogTagVisible: false,
      form: {
        name: '',
        pro_id: '',
      },
      rules: {
        pro_id: [
          { required: true, message: '请输入项目ID', trigger: 'blur' },
        ],
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
      },
    };
  },
  filters: {

  },
  components: {},
  watch: {},
  computed: {},
  created() {
    this.getList();
  },
  mounted() {},
  methods: {
    async getList() {
      const { data } = await getBluetooth();
      this.tableData = data || [];
    },
    toAddNew() {
      this.dialogFormVisible = true;
      this.form = {
        name: '',
        pro_id: '',
      };
    },
    jump(path, row) {
      this.$router.push({
        path,
      });
    },
    async viewData(row) {
      console.log(row);
      const { data } = await getTag({
        project_id: row.id,
      });
      this.tag = data || [];
      this.dialogTagVisible = true;
    },
    delData(row) {
      this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        console.log(row);
        const target = {
          pro_id: row.id,
          action: 'del',
          data: {
          },
        };
        await actionBluetooth(target);
        this.getList();
        this.$notify({
          type: 'success',
          message: '删除成功!',
        });
      }).catch(() => {

      });
    },
    async handleAdd() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const target = {
            pro_id: this.form.pro_id,
            action: 'add',
            data: {
              pname: this.form.name,
              file_dir: '',
            },
          };
          await actionBluetooth(target);
          this.getList();
          this.dialogFormVisible = false;
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="less">
.offline{
  padding:20px;
  &-title{
    background: #fff;
    padding:10px;
    border-radius: 10px;
    display: flex;
    justify-content: flex-end;
    label{
      margin-right:20px;
    }
  }
  &-body{
    margin-top:20px;
    .dataTable,.pagebar{
      margin-top:15px;
    }

    .pagebar{
      text-align: center;
    }

  }
}
</style>
